module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.help_text) ? _c('span', [(!_vm.showingHelpText) ? [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleHelpText($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" ")])])] : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleHelpText($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('HelpTextDisplay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingHelpText),
      expression: "showingHelpText"
    }],
    attrs: {
      "help_text": _vm.help_text
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44a2c026"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/help_text.vue
// module id = 966
// module chunks = 0